//**************************************************************************************************
//  ローディングサービス
//**************************************************************************************************
//==================================================================================================
//  import
//==================================================================================================
import { Injectable } from '@angular/core';
import { Overlay, OverlayRef } from '@angular/cdk/overlay';
import { ComponentPortal } from '@angular/cdk/portal';
import { LoadingComponent } from '../loading/loading.component';
//==================================================================================================
export interface LoadingRef {
  close(): void;
}
//==================================================================================================
@Injectable({
  providedIn: 'root'
})
//==================================================================================================
//
//==================================================================================================
export class LoadingService {
  //================================================================================================
  //  コンストラクタ
  //============================|===================================================================
  constructor(
    private readonly _overlay: Overlay) { }
  //================================================================================================
  //  表示
  //================================================================================================
  show(): LoadingRef {
    const overlayRef = this._createOverlay();
    const portal = new ComponentPortal(LoadingComponent);
    overlayRef.attach(portal);
    return {
      close() {
        overlayRef.detach();
        overlayRef.dispose();
      }
    };
  }
  //================================================================================================
  //  オーバーレイ作成
  //================================================================================================
  private _createOverlay(): OverlayRef {
    return this._overlay.create({
      width: '100%',
      height: '100%',
    });
  }

}
